import React from 'react';
import PropTypes from 'prop-types';
import CountdownTimer from './CountdownTimer';
import { assetUrl } from '../../config/asset-config';

/**
 * Component for displaying various processing overlays and messages during recording and uploading.
 * It includes overlays for upload progress, processing status, and error messages.
 */
const RecorderProcessors = ({
    status,
    percentage,
    trans,
    videoSource,
    updateRecordingTimeLimit = () => { },
    updateStatus = () => { },
}) => (
    <>
        {/* Section indicating upload completion */}
        {
            status === 'uploadComplete' && (
                <div className="recorder-overlay loading">
                    <i className="fa fa-spinner fa-spin loading-icon" style={{ fontSize: '8em' }}></i>
                </div>
            )
        }

        {/* Countdown timer component */}
        <CountdownTimer status={status} updateRecordingTimeLimit={updateRecordingTimeLimit} updateStatus={updateStatus} />

        {/* Section for indicating uploading progress */}
        {
            status === 'uploading' && (
                <div className="recorder-overlay uploading">
                    <h2>{trans.processing}</h2>
                    <p className="font-blue-48 flex justify-content-center align-items-center">
                        {percentage ? percentage + '%' : ''}
                        <i className="fa fa-spinner fa-spin font-blue-48" style={{ fontSize: 40, marginLeft: 10 }}></i>
                    </p>
                </div>
            )
        }

        {/* Section indicating failure with video source */}
        {
            status === 'reviewFailed' && videoSource != null && <div className="recorder-overlay video-icon" thumb-transform="true" video="video">
                <i className="fa fas-play-circle" aria-hidden="true"></i>
            </div>
        }

        {/* Section indicating failure without video source */}
        {
            status === 'reviewFailed' && videoSource == null && (
                <div className="recorder-overlay video-icon">
                    <img className="width-100" src={assetUrl('assets/img/splicing/processingVideo.png')} alt="" />
                </div>
            )
        }

        {/* Section indicating upload failure */}
        {
            status === 'uploadFailed' && <div className="recorder-overlay error-detected">
                <h2><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Processing Error</h2>
                <p className="subtext">There was an error processing your video. Please check your internet connection and try again.</p>
            </div>
        }
    </>
);

RecorderProcessors.propTypes = {
    status: PropTypes.string,
    trans: PropTypes.object,
    videoSource: PropTypes.object,
    percentage: PropTypes.number,
    updateRecordingTimeLimit: PropTypes.func,
    updateStatus: PropTypes.func,
};

export default RecorderProcessors;
